import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9.707 5.293l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 1 1 -1.414 -1.414l5.293 -5.293l-5.293 -5.293a1 1 0 0 1 1.414 -1.414","key":"svg-0"}]]

const IconChevronRightFilled = createReactComponent('filled', 'chevron-right-filled', 'ChevronRightFilled', __iconNode);

export default IconChevronRightFilled;